export type GMOTokenResponse = {
  resultCode: ResultCode
  tokenObject: GMOTokenObject
}

export type GMOTokenObject = {
  token: string
  maskedCardNo: string
}

export type ResultCode = ErrCode | '000'

export type ErrCode = keyof typeof ErrMessage

export const ErrMessage = {
  100: '(E_CP_E100) カード番号は必須です',
  101: '(E_CP_E101) カード番号のフォーマットが不正です(数字以外を含む)',
  102: '(E_CP_E102) カード番号フォーマットが不正です(10-16 桁の範囲外)',
  110: '(E_CP_E110) カード有効期限は必須です',
  111: '(E_CP_E111) カード有効期限のフォーマットが不正です(数字以外を含む)',
  112: '(E_CP_E112) カード有効期限のフォーマットが不正です(6 又は4 桁以外)',
  113: '(E_CP_E113) カード有効期限のフォーマットが不正です(月が13 以上)',
  121: '(E_CP_E121) セキュリティコードフォーマットが不正です(数字以外を含む)',
  122: '(E_CP_E122) セキュリティコード桁数が不正です',
  131: '(E_CP_E131) カード名義のフォーマットが不正です(半角英数字、一部の記号以外を含む)',
  132: '(E_CP_E132) カード名義のフォーマットが不正です(51 桁以上)',
  141: '(E_CP_E141) カード決済システムエラーです。お問い合わせください。',
  142: '(E_CP_E142) カード決済システムエラーです。お問い合わせください。',
  150: '(E_CP_E150) カード決済システムエラーです。お問い合わせください。',
  160: '(E_CP_E160) カード決済システムエラーです。お問い合わせください。',
  161: '(E_CP_E161) カード決済システムエラーです。お問い合わせください。',
  162: '(E_CP_E162) カード決済システムエラーです。お問い合わせください。',
  170: '(E_CP_E170) カード決済システムエラーです。お問い合わせください。',
  180: '(E_CP_E180) カード決済システムエラーです。お問い合わせください。',
  190: '(E_CP_E190) カード決済システムエラーです。お問い合わせください。',
  191: '(E_CP_E191) カード決済システムエラーです。お問い合わせください。',
  501: '(E_CP_E501) カード決済システムエラーです。お問い合わせください。',
  511: '(E_CP_E511) カード決済システムエラーです。お問い合わせください。',
  512: '(E_CP_E512) カード決済システムエラーです。お問い合わせください。',
  521: '(E_CP_E521) カード決済システムエラーです。お問い合わせください。',
  522: '(E_CP_E522) カード決済システムエラーです。お問い合わせください。',
  531: '(E_CP_E531) カード決済システムエラーです。お問い合わせください。',
  541: '(E_CP_E541) カード決済システムエラーです。お問い合わせください。',
  551: '(E_CP_E551) カード決済システムエラーです。お問い合わせください。',
  552: '(E_CP_E552) カード決済システムエラーです。お問い合わせください。',
  701: '(E_CP_E701) カード決済システムエラーです。お問い合わせください。',
  901: '(E_CP_E901) カード決済システムエラーです。しばらく経ってから再度お試しください。',
  902: '(E_CP_E902) カード決済システムの処理が込み合っています。しばらく経ってから再度お試しください。',
} as const
